<!-- ----------------------------------------------- -->
<template>
  <transition name="modal" appear>
    <div class="com-modal com-modal-overlay" @click.self="$emit('close')">
      <v-col
        class="com-pc-card pa-0"
        style="width: 90%; height: 90%;"
        ref="cctvBox"
      >
        <v-row class="com-pc-card-header">
          <span class="com-pc-card-title">{{ text.title }}</span>
          <v-spacer></v-spacer>
          <v-btn small text icon color="white" @click="$emit('close')">
            <v-icon>highlight_off</v-icon>
          </v-btn>
        </v-row>
        <v-col class="com-pc-card-contents">
          <v-col class="tm-pc-graph-select-box pa-0">
            <v-row class="pa-1"> </v-row>
          </v-col>
          <v-col>
            <tm-sw-cctv :height="height" :isDlg="true"></tm-sw-cctv>
          </v-col>
        </v-col>
      </v-col>
    </div>
  </transition>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]危機管理 河川カメラダイアログ
 * TmSwCctvDlg.vue
 * @author ILUKE
 */

import TmSwCctv from "./TmSwCctv.vue";

export default {
  name: "tm-ws-cctv-dlg",
  components: {
    TmSwCctv,
  },
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "河川カメラ",
      },
      height: "600px",
    };
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
